import gql from 'graphql-tag';

const CAMPAIGN_ORDER_SESSIONS = gql`
 query CampaignOrderSessionsReport($where: CampaignOrderWhereUniqueInput!) {
    campaignOrder(where: $where) {
      id
      reportDetails {
        id
        sessions {
          id
          sessions
          avgSessionDuration
          totalSessionDuration
          pagesPerSession
          sessionPageViews
          impressions
          byDate {
            key
            date
            sessions
            averageSessionDuration
            pagesPerSession
            totalSessionDuration
            impressions
          }
          byDateBreakdown {
            date
            desktop
            mobile
            tablet
          }
        }
      }
    }
  }
`;

export default CAMPAIGN_ORDER_SESSIONS;
